import { privPostRequest } from "../vidCloud/priv";

const SignatureDelegationService = {};

SignatureDelegationService.signatureDelegation = (signerGuid, body) => {
  return privPostRequest(`/signaturedelegation/${signerGuid}`, body);
}

export default SignatureDelegationService;